import * as remoteAction from "../remoteAction";

export type GetExchangesActionSuccess = remoteAction.MerchantRemoteResponse<
  "GET_EXCHANGES_SUCCESS",
  any
>;
export type GetExchangesActionFailure = remoteAction.MerchantRemoteResponse<
  "GET_EXCHANGES_FAILURE",
  any
>;
export type GetExchangesActionRequest = remoteAction.MerchantRemoteResponse<
  "GET_EXCHANGES_REQUEST",
  any
>;

export interface GetExchangesAction extends remoteAction.GetRemoteRequest {
  types: {
    request: "GET_EXCHANGES_REQUEST";
    success: "GET_EXCHANGES_SUCCESS";
    failure: "GET_EXCHANGES_FAILURE";
  };
}

export interface GetExchangesActionParams {
  campaignId?: string;
}

function buildExchangesUrl({
  campaignId,
}: GetExchangesActionParams = {}): string {
  if (!campaignId) {
    return "/rewards/exchanges";
  }

  return `/rewards/exchanges?campaignId=${encodeURIComponent(campaignId)}`;
}

export function getExchangesAction(
  params?: GetExchangesActionParams
): GetExchangesAction {
  return {
    method: "GET",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "GET_EXCHANGES_FAILURE",
      request: "GET_EXCHANGES_REQUEST",
      success: "GET_EXCHANGES_SUCCESS",
    },
    https: true,
    url: buildExchangesUrl(params),
  };
}

/**
 * Fetches exchanges for a reward store widget (filtered by widget's store and ledger currency).
 * Uses the same action types as getExchangesAction so the existing exchange reducer handles
 * the response.
 */
export function getWidgetExchangesAction(widgetId: string): GetExchangesAction {
  return {
    method: "GET",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "GET_EXCHANGES_FAILURE",
      request: "GET_EXCHANGES_REQUEST",
      success: "GET_EXCHANGES_SUCCESS",
    },
    https: true,
    url: `/rewards/reward-store-widgets/${widgetId}/exchanges`,
  };
}
